import { LOGIN_SUCCESS, SET_CONNECTION,LOGOUT ,DISCONNECT_CONNECTION} from './Authentication';

const initialState = {
  isAuthenticated: false,
  user: null,
  connection: null,
};
// const initialConneState = {
//   connection: null,
// };
const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return {
        ...state,
        isAuthenticated: true,
        user: action.payload,
      };
      case SET_CONNECTION:
      return {
        ...state,
        connection: action.payload,
      };
      case DISCONNECT_CONNECTION:
      return {
        ...state,
        connection: null,
      };
    case LOGOUT:
      return {
        ...state,
        isAuthenticated: false,
        user: null,
      };
    default:
      return state;
  }
};

export default authReducer;